import type { PageTemplate } from "@loot-os/design-system/templates/contract";
import type { InventoryContent } from "@loot-os/design-system/templates/inventory/inventoryContent";
import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";

import { RequireAuth } from "../components/RequireAuth.js";
import { SellBackDialog } from "../components/SellBackDialog.js";
import { useTenant } from "../lib/tenant.js";
import { useInventoryPage } from "../templates/pages/inventory/useInventoryPage.js";
import { storefrontTemplateOf } from "../templates/registry.js";

export function InventoryPage() {
  const { config } = useTenant();
  return (
    <RequireAuth>
      <InventoryView template={storefrontTemplateOf(config).inventory} />
    </RequireAuth>
  );
}

/**
 * The inventory (the account's Vault tab), laid out by `template`, with the sale's confirmation
 * over it. The parity suite renders this under every template.
 */
export function InventoryView({ template }: { template: PageTemplate<InventoryContent> }) {
  const { content, sale } = useInventoryPage();
  return (
    <>
      <PageTemplateView template={template} content={content} />
      {sale.open && (
        <SellBackDialog
          open={sale.open}
          onOpenChange={sale.setOpen}
          items={sale.items}
          onSold={sale.onSold}
        />
      )}
    </>
  );
}
